import {
  Card,
  DescriptionList,
  Heading,
  Layout,
} from "@vwfs-bronson/bronson-react";
import { useTranslation } from "react-i18next";
import { usePayments } from "../../hooks/usePayments";
import { usePathname } from "../../hooks/usePathname";
import { Pathname } from "../../enums";

export const PaymentsHeader = () => {
  const { t } = useTranslation("paymentpage");
  const { OverViewDetails } = usePayments();
  const { pathname } = usePathname();

  return (
    <>
      <Layout.Item default="2/3" s="1/1" className="u-text-center">
        <Heading level={1}>{t("header")}</Heading>
      </Layout.Item>
      <Layout.Item default="2/3" s="1/1" className="u-text-left">
        <Card
          subtitle={t("subHeader")}
          subtitleClassName="u-mt"
          title={t("paymentDetails.header")}
          titleLevel={2}
        >
          <DescriptionList horizontal>
            {pathname === Pathname.FLEET ? (
              <>
                <DescriptionList.Group
                  termText={t("paymentDetails.details.customerNumber")}
                >
                  <DescriptionList.Detail>
                    {OverViewDetails?.customerNumber}
                  </DescriptionList.Detail>
                </DescriptionList.Group>
                <DescriptionList.Group
                  termText={t("paymentDetails.details.companyName")}
                >
                  <DescriptionList.Detail>
                    {OverViewDetails?.companyName}
                  </DescriptionList.Detail>
                </DescriptionList.Group>
              </>
            ) : (
              <>
                <DescriptionList.Group
                  termText={t("paymentDetails.details.firstName")}
                >
                  <DescriptionList.Detail>
                    {OverViewDetails?.firstName}
                  </DescriptionList.Detail>
                </DescriptionList.Group>
                <DescriptionList.Group
                  termText={t("paymentDetails.details.lastName")}
                >
                  <DescriptionList.Detail>
                    {OverViewDetails?.surName}
                  </DescriptionList.Detail>
                </DescriptionList.Group>
              </>
            )}
            <DescriptionList.Group
              termText={t("paymentDetails.details.contract")}
            >
              <DescriptionList.Detail>
                {OverViewDetails?.contractNumber}
              </DescriptionList.Detail>
            </DescriptionList.Group>
            <DescriptionList.Group
              termText={<>{t("paymentDetails.details.payment")}</>}
            >
              <DescriptionList.Detail>
                {OverViewDetails?.outstandingBalance?.toFixed(2)} €
              </DescriptionList.Detail>
            </DescriptionList.Group>
          </DescriptionList>
        </Card>
      </Layout.Item>
    </>
  );
};

export default PaymentsHeader;
